import { render } from "./pilot-achievement.vue?vue&type=template&id=69954348&scoped=true"
import script from "./pilot-achievement.vue?vue&type=script&lang=js"
export * from "./pilot-achievement.vue?vue&type=script&lang=js"

import "./pilot-achievement.vue?vue&type=style&index=0&id=69954348&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69954348"]])

export default __exports__